export default { sha: 'a8c49eb304aa361b2644136478f89468755ef617', buildNumber: 'undefined' }
